module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "md10": ""
    }
  }, [_c('v-card', [(_vm.project) ? _c('v-form', {
    ref: "createItemForm",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.validForm),
      callback: function($$v) {
        _vm.validForm = $$v
      },
      expression: "validForm"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', _vm._b({}, 'v-layout', _vm.layout, false), [_c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('upload', {
    attrs: {
      "project": _vm.project
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md9": "",
      "px-4": ""
    }
  }, [_c('steps', {
    attrs: {
      "project": _vm.project,
      "shipping-address": _vm.shippingAddress,
      "shipping-method": _vm.shippingMethod
    },
    on: {
      "save-shipping-address": function($event) {
        return _vm.saveShippingAddress($event)
      },
      "save-shipping-method": function($event) {
        return _vm.saveShippingMethod($event)
      },
      "save-project": function($event) {
        return _vm.saveItem($event)
      }
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-card', {
    staticClass: "sticky"
  }, [_c('item-summary', {
    attrs: {
      "project": _vm.project,
      "valid": _vm.valid,
      "has-files": _vm.hasFiles
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f5161f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/proxy/create/item.vue
// module id = 726
// module chunks = 1